import { LogLevel, log } from "@modules/util/logger"
import { Cookie } from "../util/Cookie"
import { cookieModalAdditionalSelection, cookieModalSelection } from "./cookie-modal-data"
import "./cookie-modal.css"
import { isMobile } from "@modules/util/device.ts"
import "@lds/core/lds-switch.js"
import { clearTrapFocus, trapFocus } from "@modules/global/accessibilty.ts"

const googleAnalyticsScriptId = "google-analytics-script"
const googleAnalyticsScriptConfigId = "google-analytics-script-config"
const googleAnalyticsSeparatedScriptId = "google-analytics-separated-script"
const googleAnalyticsSeparatedNoScriptId = "google-analytics-separated-no-script"
const hotjarScriptId = "hotjar-script"

const modalOpenTrigger = document.getElementsByClassName("open-cookie-modal-trigger")
for (const trigger of modalOpenTrigger) {
    trigger.addEventListener("click", openCookieModal)
}
document.getElementById("submit-cookie-overlay")?.addEventListener("click", () => submitCookieModal())
document.getElementById("submit-cookie-overlay-all")?.addEventListener("click", () => submitCookieModal(true))

const cookieOverlay = new Cookie("ladies-cookies-overlay", {
    path: "/",
    domain: SiteInfo.cookieDomain,
    expires: calculateCookieExpire(),
    secure: location.protocol === "https:",
})

// check if on whiteListedPage
const whitelistPages = ["/info/datenschutz", "/impressum"]
const pagePath = window.location.pathname
const isOnWhitelistPage = whitelistPages.includes(pagePath)

// check if Useragent is Bot
const botList = [
    "Googlebot",
    "Bingbot",
    "Slurp",
    "DuckDuckBot",
    "Baiduspider",
    "YandexBot",
    "Sogou",
    "Exabot",
    "facebot",
    "facebookexternalhit",
    "ia_archiver",
]
const userAgent = window.navigator.userAgent
const isBotUseragent = botList.some((botString) => userAgent.includes(botString))

const googleAnalyticsKey = "G-E7QCER61HM"
const tagManagerId = isMobile() ? "GTM-PHVVXVK" : "GTM-5SPH9HW"

// init gtag function because of possible call order error
window.dataLayer = window.dataLayer || []
// biome-ignore lint: well gtag we dont know what theyll be. TODO fix
window.gtag = (...args: any) => {
    window.dataLayer.push(...args)
}

if (cookieOverlay.value) {
    try {
        let cookieOverlayValue = cookieOverlay.value
        // on some portals cookie.value is already parsed...?
        if (cookieOverlayValue && typeof cookieOverlayValue !== "object") {
            cookieOverlayValue = JSON.parse(cookieOverlay.value)
        }
        // TODO: hardcoded key - refactor?
        if (cookieOverlayValue["cookie-category-stats"]) {
            grantGoogleAnalyticsConsent()
        } else {
            deleteUnnecessaryCookies(cookieOverlayValue)
        }
    } catch (error) {
        console.error(error)
    }
}

function registerCookieModalEvents() {
    for (const toggle of document.querySelectorAll(".site-cookies-overlay .cookie-info-toggle")) {
        toggle.addEventListener("click", (e) => {
            const el = e.target as HTMLElement
            // in case checkbox was clicked
            if (el.classList.contains("cookie-checkbox")) {
                return
            }

            let containerElement = el.parentElement

            if (containerElement?.classList.contains("cookie-info-toggle")) {
                containerElement = containerElement.parentElement
            }

            containerElement?.classList.toggle("active")
        })
    }
}

function calculateCookieExpire() {
    // expire in 90 days
    return new Date(Date.now() + 1000 * 60 * 60 * 24 * 90).toUTCString()
}

function submitCookieModal(allAccepted = false) {
    if (typeof closeCookieModal !== "undefined") {
        closeCookieModal()
    } else {
        console.error("Not able to close cookie-overlay modal!")
    }

    // write selection to cookie
    const newCookieValue: Record<string, boolean> = {}
    for (const checkbox of document.querySelectorAll<HTMLInputElement>(".cookie-checkbox")) {
        newCookieValue[checkbox.getAttribute("id") as string] = allAccepted || checkbox.checked
    }
    // set expire with actual time
    cookieOverlay.expires = calculateCookieExpire()
    cookieOverlay.value = JSON.stringify(newCookieValue)

    // TODO: hardcoded key - refactor?
    if (newCookieValue["cookie-category-stats"]) {
        grantGoogleAnalyticsConsent()
    } else {
        declineGoogleAnalyticsConsent()
    }

    deleteUnnecessaryCookies(newCookieValue)

    document.dispatchEvent(new Event("cookieOverlaySubmitted"))
}

const closeCookieModal = () => {
    const overlay = document.querySelector<HTMLElement>(".modal.site-cookies-overlay")
    const backdrop = document.querySelector<HTMLElement>(".modal-backdrop.site-cookies-overlay")

    overlay?.classList.remove("in")
    overlay?.classList.remove("show")
    backdrop?.classList.remove("in")

    if (overlay) overlay.style.display = "none"
    if (backdrop) backdrop.style.display = "none"

    clearTrapFocus()
    document.body.classList.remove("cookie-modal-open")
    document.documentElement.classList.remove("cookie-modal-open")
    document.querySelector("main")?.removeAttribute("aria-hidden")
    document.getElementById("cookie-overlay")?.setAttribute("aria-hidden", "true")
}

function openCookieModal() {
    document.body.classList.add("cookie-modal-open")
    document.documentElement.classList.add("cookie-modal-open")

    const overlay = document.querySelector<HTMLElement>(".modal.site-cookies-overlay")
    const backdrop = document.querySelector<HTMLElement>(".modal-backdrop.site-cookies-overlay")

    if (overlay) overlay.style.display = "block"
    if (backdrop) backdrop.style.display = "block"

    overlay?.classList.add("in")
    overlay?.classList.add("show")
    backdrop?.classList.add("in")

    renderCookieSelection()

    // set checkbox values
    const checkboxes = document.querySelectorAll(".cookie-checkbox")
    for (const item of Array.from(checkboxes)) {
        if (isCategoryChecked(item.getAttribute("id") || "")) {
            item.setAttribute("checked", "true")
        }
    }

    // only call after modal content is created
    registerCookieModalEvents()

    document.querySelector("main")?.setAttribute("aria-hidden", "true")
    document.getElementById("cookie-overlay")?.removeAttribute("aria-hidden")
    trapFocus(document.getElementById("cookie-overlay") as HTMLElement)
}

window.setCookieOverlayValue = (key: string, value: string) => {
    const cookieValue = cookieOverlay.value
    cookieValue[key] = value
    cookieOverlay.value = JSON.stringify(cookieValue)
}

window.getCookieOverlayValue = (key: string) => cookieOverlay.value[key]

function isCategoryChecked(categoryName: string) {
    try {
        let cookieOverlayValue = cookieOverlay.value
        // on some portals cookie.value is already parsed...?
        if (cookieOverlayValue && typeof cookieOverlayValue !== "object") {
            cookieOverlayValue = JSON.parse(cookieOverlay.value)
        }
        const categoryValue = cookieOverlayValue[categoryName]
        if (typeof categoryValue === "string") {
            return JSON.parse(categoryValue)
        }
        return !!categoryValue
    } catch (error) {
        console.error(error)
        return false
    }
}

function escapeHtml(text: string) {
    const map: Record<string, string> = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;",
    }

    return text.replace(/[&<>"']/g, (m) => map[m])
}

function renderCookieSelection() {
    const cookieSelectionElement = document.querySelector("#cookie-selection")

    // delete content in case of rerender
    while (cookieSelectionElement?.lastChild) {
        cookieSelectionElement.removeChild(cookieSelectionElement.lastChild)
    }
    if (cookieModalSelection?.data?.length) {
        for (const category of cookieModalSelection.data) {
            document.querySelector("#cookie-selection")?.insertAdjacentHTML(
                "beforeend",
                `<div class="cookie-category">
                        <div class="cookie-info-row">
                            <label class="category-title cookie-check ${!category.choosable ? "selection-disabled" : ""}">${escapeHtml(category.label)}
                                <input class="cookie-checkbox" type="checkbox" id="cookie-category-${category.name}" ${!category.choosable ? "disabled checked" : isCategoryChecked(`cookie-category-${category.name}`) ? "checked" : ""} >
                                <span class="checkmark"></span>
                            </label>
                            <svg class="cookie-info-toggle" viewBox="0 0 20 20">
                                <path xmlns="http://www.w3.org/2000/svg" d="M20 5.804l-10 10-10-10 1.609-1.609 8.391 8.391 8.391-8.391z"/>
                            </svg>
                        </div>
                        <div class="cookie-info">
                            <div class="cookie-info-text">${category.description_consent}</div>
                            <div id="cookie-list-${category.name}" class="cookie-list"></div>
                        </div>
                    </div>`,
            )

            if (!category.itemize_dse_only && category.authors && category.authors.length) {
                for (const author of category.authors) {
                    if (author.description_consent) {
                        document.querySelector(`#cookie-list-${category.name}`)?.insertAdjacentHTML(
                            "beforeend",
                            `
                                <div class="cookie-list-text">
                                    <span class="cookie-title">${escapeHtml(author.label)}</span><br><br>
                                    ${author.description_consent}
                                </div>
                            `,
                        )
                    }
                    if (author.owner) {
                        document.querySelector(`#cookie-list-${category.name}`)?.insertAdjacentHTML(
                            "beforeend",
                            `
                                <div class="cookie-list-text">
                                    <span class="cookie-list-title">Herausgeber:</span><br>
                                    ${author.owner}
                                </div>
                            `,
                        )
                    }
                    if (author.collected_data) {
                        document.querySelector(`#cookie-list-${category.name}`)?.insertAdjacentHTML(
                            "beforeend",
                            `
                                <div class="cookie-list-text">
                                    <span class="cookie-list-title">Erhobene Daten:</span><br>
                                    ${author.collected_data}
                                </div>
                            `,
                        )
                    }
                    if (author.processing_location) {
                        document.querySelector(`#cookie-list-${category.name}`)?.insertAdjacentHTML(
                            "beforeend",
                            `
                                <div class="cookie-list-text">
                                    <span class="cookie-list-title">Ort der Verarbeitung:</span><br>
                                    ${author.processing_location}
                                </div>
                            `,
                        )
                    }
                }
            }
        }
    } else {
        cookieSelectionElement?.insertAdjacentHTML(
            "beforeend",
            "<p class='cookie-api-error'>Es gab leider Probleme beim Abfragen der Cookie Daten. <br>Bitte laden Sie die Seite neu!</p>",
        )
    }

    if (cookieModalAdditionalSelection?.data?.length) {
        for (const category of cookieModalAdditionalSelection.data) {
            document.querySelector("#cookie-selection")?.insertAdjacentHTML(
                "beforeend",
                `<div class="cookie-category">
                        <div class="cookie-info-row">
                            <label class="category-title cookie-check">${escapeHtml(category.label)}
                                <input class="cookie-checkbox" type="checkbox" id="cookie-category-${category.name}" ${isCategoryChecked(`cookie-category-${category.name}`) ? "checked" : ""} >
                                <span class="checkmark"></span>
                            </label>
                            <svg class="cookie-info-toggle" viewBox="0 0 20 20">
                                <path xmlns="http://www.w3.org/2000/svg" d="M20 5.804l-10 10-10-10 1.609-1.609 8.391 8.391 8.391-8.391z"/>
                            </svg>
                        </div>
                        <div class="cookie-info">
                            <div class="cookie-info-text">${category.description}</div>
                        </div>
                    </div>`,
            )
        }
    }
}

function deleteUnnecessaryCookies(newCookieValue: object) {
    // cookie deletion logic
    for (const [key, value] of Object.entries(newCookieValue)) {
        if (value === false && cookieModalSelection.data) {
            const matchedCategory = cookieModalSelection.data.find((element) => {
                // TODO: hardcoded prefix - refactor
                return `cookie-category-${element.name}` === key
            })
            if (matchedCategory?.choosable) {
                for (const author of matchedCategory.authors) {
                    for (const cookie of author.cookies) {
                        for (const existingCookie of document.cookie.split(";")) {
                            const cookieName = existingCookie.trim().split("=")[0]

                            // check if cookie.label includes placeholder
                            if (cookie.label.includes("*")) {
                                if (!cookieName.includes(cookie.label.replace("*", ""))) {
                                    continue
                                }
                            } else {
                                if (cookie.label !== cookieName) {
                                    continue
                                }
                            }
                            // Remove the cookie
                            log(LogLevel.DEBUG, `deleting cookie ${cookieName}`)
                            document.cookie = `${cookieName}=; Max-Age=0; path=/; domain=${SiteInfo.cookieDomain}`
                        }
                    }
                }
            }
        }
    }
}

function grantGoogleAnalyticsConsent() {
    const googleTagScript = document.createElement("script")
    googleTagScript.id = googleAnalyticsScriptId
    googleTagScript.src = `https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsKey}`
    googleTagScript.async = true

    const googleTagScriptConfig = document.createElement("script")
    googleTagScriptConfig.id = googleAnalyticsScriptConfigId
    googleTagScriptConfig.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}

            gtag('js', new Date());
            gtag('config', '${googleAnalyticsKey}');
        `

    const googleTagSeparatedScript = document.createElement("script")
    googleTagSeparatedScript.id = googleAnalyticsSeparatedScriptId
    googleTagSeparatedScript.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push(
            {'gtm.start': new Date().getTime(),event:'gtm.js'}
        );var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer', '${tagManagerId}');`

    const googleTagSeparatedNoScript = document.createElement("noscript")
    googleTagSeparatedNoScript.id = googleAnalyticsSeparatedNoScriptId
    const googleTagNoScriptIframe = document.createElement("iframe")
    googleTagNoScriptIframe.src = `https://www.googletagmanager.com/ns.html?id=${tagManagerId}`
    googleTagNoScriptIframe.height = "0"
    googleTagNoScriptIframe.width = "0"
    googleTagNoScriptIframe.style.display = "none"
    googleTagNoScriptIframe.style.visibility = "hidden"
    googleTagSeparatedNoScript.appendChild(googleTagNoScriptIframe)

    const hotjarScript = document.createElement("script")
    hotjarScript.id = hotjarScriptId
    hotjarScript.innerHTML =
        "(function(h,o,t,j,a,r){ h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)}; h._hjSettings={hjid:2626518,hjsv:6}; a=o.getElementsByTagName('head')[0]; r=o.createElement('script');r.async=1; r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv; a.appendChild(r); })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');"

    if (document.getElementById(googleAnalyticsScriptId) === null) {
        document.body.appendChild(googleTagScript)
    }
    if (document.getElementById(googleAnalyticsScriptConfigId) === null) {
        document.body.appendChild(googleTagScriptConfig)
    }
    if (document.getElementById(googleAnalyticsSeparatedScriptId) === null) {
        document.body.appendChild(googleTagSeparatedScript)
    }
    if (document.getElementById(googleAnalyticsSeparatedNoScriptId) === null) {
        document.body.appendChild(googleTagSeparatedNoScript)
    }
    if (document.getElementById(hotjarScriptId) === null) {
        document.body.appendChild(hotjarScript)
    }
}

function declineGoogleAnalyticsConsent() {
    const scriptBlock = document.getElementById(googleAnalyticsScriptId)
    if (typeof scriptBlock !== "undefined" && scriptBlock !== null) {
        scriptBlock.remove()
    }
    const configBlock = document.getElementById(googleAnalyticsScriptConfigId)
    if (typeof configBlock !== "undefined" && configBlock !== null) {
        configBlock.remove()
    }
    const separatedScriptBlock = document.getElementById(googleAnalyticsSeparatedScriptId)
    if (typeof separatedScriptBlock !== "undefined" && separatedScriptBlock !== null) {
        separatedScriptBlock.remove()
    }
    const noScriptBlock = document.getElementById(googleAnalyticsSeparatedNoScriptId)
    if (typeof noScriptBlock !== "undefined" && noScriptBlock !== null) {
        noScriptBlock.remove()
    }
    const hotjarBlock = document.getElementById(hotjarScriptId)
    if (typeof hotjarBlock !== "undefined" && hotjarBlock !== null) {
        hotjarBlock.remove()
    }
    const remainingScriptBlocks = document.querySelectorAll('[src^="https://www.googletagmanager.com"]')
    for (const remainingScript of remainingScriptBlocks) {
        remainingScript.remove()
    }
}

if (isOnWhitelistPage || isBotUseragent) {
    log(LogLevel.DEBUG, "Cookie Overlay not displayed!")
} else if (cookieOverlay.value === "") {
    openCookieModal()
}
